import React from 'react';
import PropTypes from 'prop-types';
import ReactTable from 'react-table';

import withLoadingList from '../../../common/hoc/withLoaingList';

const SplitsList = ({ shops, columns }) => (
  <ReactTable
    data={shops}
    showPagination={false}
    minRows={0}
    defaultPageSize={100}
    className="c-table-new c-no-hover c-table--small u-mt"
    columns={columns}
  />
);

SplitsList.propTypes = {
  shops: PropTypes.array.isRequired,
  columns: PropTypes.array.isRequired,
};

export default withLoadingList(
  props => props.shops,
  () => null,
)(SplitsList);
